import { render, staticRenderFns } from "./DelPersonForm.vue?vue&type=template&id=7c1e422d&scoped=true"
import script from "./DelPersonForm.vue?vue&type=script&lang=js"
export * from "./DelPersonForm.vue?vue&type=script&lang=js"
import style0 from "./DelPersonForm.vue?vue&type=style&index=0&id=7c1e422d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1e422d",
  null
  
)

export default component.exports